import { useMemo } from 'react'
import { format, parseISO } from 'date-fns'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    let subscribers = new Map()

    data.map(item => {
      let id = item.user_id

      if (!subscribers.has(id)) {
        subscribers.set(id, {
          id: id,
          employee_email: item.user?.account?.email || '',
          employee_name: `${
            item.user?.vaxiom_person?.first_name || 'Support'
          } ${item.user?.vaxiom_person?.last_name || ''} `,
          created_details: `${
            item.created_by_user?.vaxiom_person?.first_name || 'Support'
          } ${item.created_by_user?.vaxiom_person?.last_name || ''}, ${format(
            parseISO(item.created_at),
            'd MMM yy'
          )}`,
          stages: [],
        })
      }

      subscribers.get(id).stages.push(item.stage)

      return true
    })

    let result = Array.from(subscribers.values())

    return result
  }, [data]) // eslint-disable-line
}
